import React, { PureComponent } from 'react';
import DropboxChooser from 'react-dropbox-chooser';
import { withTranslation } from 'react-i18next';

import config from '../config';
import { externalLoad } from '../api/files-api';
import { createAlert } from '../services/alert-service';

class DropboxFileChooser extends PureComponent {
    handleSuccess = files => {
        const { t } = this.props;

        if (this.props.onChange) {
            this.props.onChange(files.map(file => ({
                ...file,
                serviceType: 'dropbox',
                serviceProps: {
                    type: 'dropbox',
                    link: file.link,
                    name: file.name,
                    size: file.bytes
                }
            })));
            return;
        }

        let alertText;

        if (files.length === 1) {
            alertText = (
                <React.Fragment>
                    <i className="icon material-icons icon-animate-rotate">autorenew</i> { t('Importing file', { file: files[0].name }) }
                </React.Fragment>
            );
        } else {
            alertText = (
                <React.Fragment>
                    <i className="icon material-icons icon-animate-rotate">autorenew</i> { t('Importing files', { count: files.length }) }
                </React.Fragment>
            );
        }

        const alert = createAlert('success', alertText, {
            duration: 0
        });

        externalLoad({
            project: this.props.projectId,
            task: this.props.taskId,
            doc: this.props.docId,
            files: files.map(({ link, name, bytes: size }) => ({
                type: 'dropbox',
                link,
                name,
                size
            })),
            folder_id: this.props.folderId,
            folder_stack: this.props.folderStack
        }).then(response => {
            alert.setContent(
                <React.Fragment>
                    <i className="icon material-icons icon-animate-rotate">autorenew</i> { t('Files imported', { count: files.length }) }
                </React.Fragment>
            );
            alert.hide(5000);
        });
    }

    render() {
        return (
            <DropboxChooser 
                appKey={config.DROPBOX.APP_KEY}
                success={this.handleSuccess}
                linkType="direct"
                multiselect={true}
            >
                {this.props.children}
            </DropboxChooser>
        )
    }
}

export default withTranslation('file')(DropboxFileChooser);
